import { alpha, Chip } from "@mui/material";

import { ChipLabel } from "@/components/elements/chip-label";

interface ApplicationUnassignedDisclosuresChipProps {
  unassigned_disclosures: number;
}

export function ApplicationUnassignedDisclosuresChip({
  unassigned_disclosures,
}: ApplicationUnassignedDisclosuresChipProps) {
  return (
    <Chip
      variant="outlined"
      label={
        <ChipLabel
          name="Unassigned disclosures"
          count={unassigned_disclosures}
          sx={{ bgcolor: (theme) => theme.palette.error.light }}
        />
      }
      size="small"
      sx={{
        borderRadius: 1,
        color: (theme) => theme.palette.error.dark,
        bgcolor: (theme) => alpha(theme.palette.error.dark, 0.08),
        border: "none",
        maxWidth: 200,
      }}
    />
  );
}
